import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  ButtonsModule,
  CardModule,
  DropdownModule,
  InputModule,
  LoadingService,
  RadioButtonModule,
} from 'axis-components';
import { AxisValidatorModule } from 'axis-components/customValidators';
import { Logger } from '../../../_core/logger.service';
import { PdfService } from '../../../_services/pdf/pdf.service';
import { RequestService } from '../../../_services/request/request.service';
import { NondigitalService } from '../../../_services/uim-ui/nondigital.service';
import { UserService } from '../../../_services/user.service';
import { AnalyticsService } from '../../../_shared/analytics/analytics.service';
import {
  FormType,
  RequestProgressStep,
  PDFGenerationStatus,
} from '../../../config/constants';
import { NonDigitalContent } from '../uimui-thankyou/uimui-thankyou.constants';
import { UimuiBaseStateComponent } from '../../../state-disclosures/uimui/uimui-base-state.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-uimui-non-digital-elections',
  templateUrl: './uimui-non-digital-elections.component.html',
  styleUrls: ['./uimui-non-digital-elections.component.scss'],
  standalone: true,
  imports: [
    ButtonsModule,
    CardModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    RadioButtonModule,
    ReactiveFormsModule,
    AxisValidatorModule,
    InputModule,
    RouterModule,
  ],
})
export class UimuiNonDigitalElectionsComponent {
  public uninsuredNonDigi: FormGroup;
  dropdownErrorBlurred = true;
  accountDetails: any = null;

  public mySettings110: any = {
    reg_exp: '^[-\\d]+$',
  };

  constructor(
    private readonly nondigitalService: NondigitalService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
    private requestService: RequestService,
    private analyticsService: AnalyticsService,
    private pdfService: PdfService,
    private loadingService: LoadingService,
  ) {}
  nonDigital: any;
  formData: any = {};
  selectedOption = '';
  userRole;
  requestKey = '';
  content = NonDigitalContent.WithPip;

  @Output() optionSelected = new EventEmitter<string>();

  public stateList = [
    { name: 'Alabama', id: 'AL' },
    { name: 'Alaska', id: 'AK' },
    { name: 'Arizona', id: 'AZ' },
    { name: 'Arkansas', id: 'AR' },
    { name: 'California', id: 'CA' },
    { name: 'Colorado', id: 'CO' },
    { name: 'Connecticut', id: 'CT' },
    { name: 'Delaware', id: 'DE' },
    { name: 'Florida', id: 'FL' },
    { name: 'Georgia', id: 'GA' },
    { name: 'Hawaii', id: 'HI' },
    { name: 'Idaho', id: 'ID' },
    { name: 'Illinois', id: 'IL' },
    { name: 'Indiana', id: 'IN' },
    { name: 'Iowa', id: 'IA' },
    { name: 'Kansas', id: 'KS' },
    { name: 'Kentucky', id: 'KY' },
    { name: 'Louisiana', id: 'LA' },
    { name: 'Maine', id: 'ME' },
    { name: 'Maryland', id: 'MD' },
    { name: 'Massachusetts', id: 'MA' },
    { name: 'Michigan', id: 'MI' },
    { name: 'Minnesota', id: 'MN' },
    { name: 'Mississippi', id: 'MS' },
    { name: 'Missouri', id: 'MO' },
    { name: 'Montana', id: 'MT' },
    { name: 'Nebraska', id: 'NE' },
    { name: 'Nevada', id: 'NV' },
    { name: 'New Hampshire', id: 'NH' },
    { name: 'New Jersey', id: 'NJ' },
    { name: 'New Mexico', id: 'NM' },
    { name: 'New York', id: 'NY' },
    { name: 'North Carolina', id: 'NC' },
    { name: 'North Dakota', id: 'ND' },
    { name: 'Ohio', id: 'OH' },
    { name: 'Oklahoma', id: 'OK' },
    { name: 'Oregon', id: 'OR' },
    { name: 'Pennsylvania', id: 'PA' },
    { name: 'Rhode Island', id: 'RI' },
    { name: 'South Carolina', id: 'SC' },
    { name: 'South Dakota', id: 'SD' },
    { name: 'Tennessee', id: 'TN' },
    { name: 'Texas', id: 'TX' },
    { name: 'Utah', id: 'UT' },
    { name: 'Vermont', id: 'VT' },
    { name: 'Virginia', id: 'VA' },
    { name: 'Washington', id: 'WA' },
    { name: 'West Virginia', id: 'WV' },
    { name: 'Wisconsin', id: 'WI' },
    { name: 'Wyoming', id: 'WY' },
  ];

  ngOnInit() {
    this.getAccountDetails();
    this.userRole = this.userService.role;
    this.requestKey = this.requestService.getRequestKey() || '';
    this.nondigitalService.getNonDigitalData().subscribe((data) => {
      this.nonDigital = data;
    });
    this.uninsuredNonDigi = this.fb.group({
      rejectDigiSelect: ['', Validators.required],
      rejInsuredName: [
        this.accountDetails.insuredName || '',
        Validators.required,
      ],
      rejInsuredMail: [
        this.accountDetails.insuredEmail || '',
        Validators.required,
      ],
      rejInsuredAddress: [
        this.accountDetails.address || '',
        Validators.required,
      ],
      rejInsuredCity: [this.accountDetails.city || '', Validators.required],
      rejInsuredState: [this.accountDetails.state || '', Validators.required],
      rejInsuredZipCode: [
        this.accountDetails.zipCode || '', //Validators.required],
        [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')],
      ],
    });
    this.goTop();
  }

  goTop(): void {
    // reset the page when changing route
    window.scrollTo(0, 0);
  }
  getAccountDetails(): void {
    if (
      this.requestService.request &&
      this.requestService.request.requestDetails &&
      this.requestService.request.requestDetails.accountDetail
    ) {
      this.accountDetails =
        this.requestService.request.requestDetails.accountDetail;
    }
  }
  updateRequestDetailsWithFormData() {
    const stateValue = this.uninsuredNonDigi.value.rejInsuredState;
    const stateCode =
      typeof stateValue === 'object' && stateValue !== null
        ? stateValue.id // Extract the state code if it's an object
        : stateValue;
    // Find the matching state object in stateList using the state code
    const stateObject = this.stateList.find((state) => state.id === stateCode);
    const stateName = stateObject ? stateObject.name : stateCode;
    // Get account detail values from the form
    const accountDetails = {
      accountDetail: {
        insuredName: this.uninsuredNonDigi.value.rejInsuredName,
        insuredEmail: this.uninsuredNonDigi.value.rejInsuredMail,
        address: this.uninsuredNonDigi.value.rejInsuredAddress,
        city: this.uninsuredNonDigi.value.rejInsuredCity,
        state: stateName,
        zipCode: this.uninsuredNonDigi.value.rejInsuredZipCode,
      },
    };
    // Update request details with new account values
    this.requestService.updateRequestDetails(accountDetails);
  }
  onOptionChange(value: string): void {
    this.selectedOption = value;
    this.uninsuredNonDigi.get('rejectDigiSelect')?.setValue(value);
    this.uninsuredNonDigi.get('rejectDigiSelect').markAsTouched();
    this.optionSelected.emit(value);
  }
  onContinue(): void {
    this.uninsuredNonDigi.get('rejectDigiSelect').markAsTouched();
    if (this.uninsuredNonDigi.get('rejectDigiSelect')?.invalid) {
      return;
    }
    this.updateRequestDetailsWithFormData();
    if (this.selectedOption === 'mail') {
      [
        'rejInsuredName',
        'rejInsuredMail',
        'rejInsuredAddress',
        'rejInsuredCity',
        'rejInsuredState',
        'rejInsuredZipCode',
      ].forEach((key) => {
        this.uninsuredNonDigi.get(key)?.markAsTouched();
      });
      if (this.uninsuredNonDigi.invalid) {
        return;
      }
    }
    if (this.selectedOption === 'digital') {
      this.router.navigate(['/insured/uimui-consent'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      if (!this.userService.role.match('broker')) {
        let step = RequestProgressStep.NON_DIGITAL_ELECTION_DOWNLOAD;
        let data = {};
        let emailType = 'nonDigitalDownload';
        if (this.selectedOption === 'download') {
          step = RequestProgressStep.NON_DIGITAL_ELECTION_DOWNLOAD;
          emailType = 'nonDigitalDownload';
        } else if (this.selectedOption === 'mail') {
          step = RequestProgressStep.NON_DIGITAL_ELECTION_SHIP_FORMS;
          emailType = 'nonDigitalShip';
          data = {
            mailingAddress: {
              insuredName: this.uninsuredNonDigi.get('rejInsuredName')?.value,
              insuredEmail: this.uninsuredNonDigi.get('rejInsuredMail')?.value,
              streetAddress:
                this.uninsuredNonDigi.get('rejInsuredAddress')?.value,
              city: this.uninsuredNonDigi.get('rejInsuredCity')?.value,
              state: this.uninsuredNonDigi.get('rejInsuredState')?.value,
              zipCode: this.uninsuredNonDigi.get('rejInsuredZipCode')?.value,
            },
          };
        }

        const submitWithCompletionGuard = (wasAlreadyCompleted: boolean) => {
          const isUimuiCompleted =
            this.requestService.isFormTypeAlreadyCompleted(FormType.UM_UIM);

          // If UM/UIM is already completed, do not continue with consent routing.
          if (isUimuiCompleted) {
            return;
          }
          UimuiBaseStateComponent.resetLoadingState();
          this.loadingService.start('Loading');
          this.requestService
            .updateRequestProgress(FormType.UM_UIM, step, data)
            .then(() => {
              const targetRoute =
                this.requestService.requestFormTypeList.length === 1 &&
                this.requestService.requestFormTypeList[0] === FormType.UM_UIM
                  ? '/thank-you'
                  : '/insured/uimui-thankyou';

              // Only emit completion when this submit newly completes the UM/UIM form.
              if (!wasAlreadyCompleted) {
                this.analyticsService.emitFormCompleteOnce(
                  FormType.UM_UIM,
                  'DigiSign:um_uim:thankYou',
                  targetRoute,
                );
              }

              this.pdfService.uiumPdfGenerationStatus =
                PDFGenerationStatus.RequestSent;
              this.pdfService
                .generateUMUIMSendEmailPdf(false, emailType)
                .pipe(
                  finalize(() => {
                    this.loadingService.stop();
                    if (targetRoute === '/thank-you') {
                      this.router.navigate(['/thank-you'], {
                        queryParamsHandling: 'preserve',
                      });
                    } else {
                      this.router.navigate(['/insured/uimui-thankyou'], {
                        queryParamsHandling: 'preserve',
                      });
                    }
                  }),
                )
                .subscribe(
                  (res) => {
                    this.pdfService.uiumPdfGenerationStatus =
                      PDFGenerationStatus.ResponseReceived;
                    return;
                  },
                  (err) => {
                    console.log('Error generating or sending UM UIM PDF', err);
                    this.pdfService.uiumPdfGenerationStatus =
                      PDFGenerationStatus.Error;
                  },
                );

              this.analyticsService.logNonDigitalElectionsEvent(
                FormType.UM_UIM,
                this.selectedOption,
              );
              //Navigate to thank You after step update
            });
        };

        // Refresh from DB before submit to guard duplicate completes across sessions/browsers.
        this.requestService.refreshRequestData(false).subscribe({
          next: () => {
            submitWithCompletionGuard(
              this.requestService.isFormTypeAlreadyCompleted(FormType.UM_UIM),
            );
          },
          error: () => {
            submitWithCompletionGuard(
              this.requestService.isFormTypeAlreadyCompleted(FormType.UM_UIM),
            );
          },
        });
      }
    }
  }

  backConsentPage(): void {
    this.router.navigate(['/insured/uimui-consent'], {
      queryParamsHandling: 'preserve',
    });
  }
}
